import * as React from "react";
const SvgFiRrWalking = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-walking_svg__a)">
      <path
        fill="#062147"
        d="M10 2.5a2.5 2.5 0 1 1 4.999 0 2.5 2.5 0 0 1-5 0m10.895 11.244a1 1 0 0 1-1.342.448l-2.842-1.421a4 4 0 0 1-1.597-1.447l-.494-.784-1.408 5.296 1.27.721A3 3 0 0 1 16 19.166v3.836a1 1 0 1 1-2 0v-3.836c0-.359-.194-.692-.506-.87l-3.977-2.258a3.02 3.02 0 0 1-1.44-3.292l1.027-4.385a6 6 0 0 0-.607.26L6.4 9.67a1 1 0 0 0-.52.638l-.782 2.951a1.001 1.001 0 0 1-1.933-.513l.783-2.951a3 3 0 0 1 1.559-1.914l2.096-1.049a7.9 7.9 0 0 1 3.518-.83H12c2.006 0 3.273 1.829 3.327 1.907l1.48 2.351c.194.31.47.56.797.723l2.843 1.422a1 1 0 0 1 .447 1.342zm-9.438 1.093 1.667-6.369c-.295-.238-.688-.467-1.124-.467h-.758l-1.217 5.2c-.1.428.097.879.48 1.097l.95.54zM9.19 17.866l-.024-.014a.977.977 0 0 0-1.454.616l-.153.661-1.61 3.452a.998.998 0 0 0 1.807.846l1.654-3.514.228-.993a.97.97 0 0 0-.45-1.055z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-walking_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWalking;
